import React from "react";
import DealWizard from "../Components/Ambassador/Deals/DealForm/DealWizard";

const AmbassadorDealFormPage: React.FC = () => <DealWizard />;

export default AmbassadorDealFormPage;
